import { useCallback, useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';

interface Output {
    showHistory: boolean;
    onMouseLeave: () => void;
    onMouseEnter: () => void;
}

const useMouseEventsHandler = (timeout: number = 600): Output => {
    const [showHistory, setShowHistory] = useState<boolean>(false);

    const timer = useRef<number>(0);

    const onMouseEnter = useCallback(
        debounce(() => {
            clearTimeout(timer.current);
            timer.current = window.setTimeout(() => {
                setShowHistory(true);
            }, timeout);
        }, 100),
        []
    );

    const onMouseLeave = useCallback(
        debounce(() => {
            clearTimeout(timer.current);
            setShowHistory(false);
        }, 100),
        []
    );

    useEffect(() => () => clearTimeout(timer.current), []);

    return {
        showHistory,
        onMouseLeave,
        onMouseEnter,
    };
};

export default useMouseEventsHandler;
